import { styled } from 'styled-components'

import { lineClamp } from '@b-stock/fe-core/bstock-next/components'
import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

// Rendered inside AuctionCard's <Extra> (a <p>), so this must stay a <span> —
// a block element here would be invalid HTML nesting.
const ReasonLabelContainer = styled.span`
  ${lineClamp(2)}
  overflow-wrap: anywhere;
`

/**
 * The "Because you viewed [title]" reason chip (BP-3104), rendered per-card
 * via BaseCarousel's `renderCardExtra` slot.
 */
export const BasedOnRecentViewsReasonLabel = ({ title }: { title: string }) => (
  <ReasonLabelContainer data-testid="based-on-recent-views-reason-label">
    <FormattedMessage
      id="Common.Carousel.basedOnRecentViewsReasonLabel"
      values={{ title }}
    />
  </ReasonLabelContainer>
)
